import React, { useEffect, useState } from 'react'
import { app } from '../../firebase'

import {
  getDatabase,
  ref,
  onValue,
  update,
  runTransaction,
  DataSnapshot,
  get,
  set,
} from 'firebase/database'

import styled from 'styled-components'
import { Switch } from 'components/Switch'
import { Select } from 'components/Select'
import { Button } from 'components/Button'
import { NumberInput } from 'components/NumberInput'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { getAuth } from 'firebase/auth'

const isMobile = window.innerWidth < 712
const getRisk = (perweek: number, heavy: boolean, gender: string) => {
  let risk = 'none'
  if (heavy) {
    risk = 'high'
  } else {
    if (
      (perweek > 0 && perweek <= 10 && gender === 'm') ||
      (perweek > 0 && perweek <= 5 && gender === 'f')
    ) {
      risk = 'low'
    }
    if (
      (perweek > 10 && perweek < 28 && gender === 'm') ||
      (perweek > 5 && perweek < 15 && gender === 'f')
    ) {
      risk = 'middle'
    }
    if (
      (perweek >= 28 && gender === 'm') ||
      (perweek >= 15 && gender === 'f')
    ) {
      risk = 'high'
    }
  }
  return risk
}
const calculateWeeklyGlasses = (drinks: number[]) => {
  return drinks.reduce((a, b) => a + b, 0)
}
const lSProp = 'alkohol_2024_christmas'

// // FIREBASE CONNECTION
// const firebaseConfig = {
//   databaseURL: 'https://2022-alkoholrechner.europe-west1.firebasedatabase.app/',
//   apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
//   projectId: 'captchadatabases',
//   storageBucket: 'captchadatabases.appspot.com',
//   authDomain: 'captchadatabases.firebaseapp.com',
//   messagingSenderId: '78621128630',
//   appId: '1:78621128630:web:5b1182f6b86e20765df317',
// }

// const appCheck = initializeAppCheck(app, {
//   provider: new ReCaptchaEnterpriseProvider("6LffZUYqAAAAAM4Fsz5zOSSAqM_6qan1Wy5Oj9Dh"), 
//   isTokenAutoRefreshEnabled: true,
// });
export const Form = ({
  getUserInputs,
  getDBData,
  TEXT,
}: {
  getUserInputs: (e: UserInputTypes) => void
  getDBData: (e: DBDataType | undefined) => void
  TEXT: { [key: string]: string | string[] | string[][] | JSX.Element }
}) => {
  const [participated, setParticipated] = useState<boolean>(false)

  const local = localStorage.getItem(lSProp)

  const [inputs, setInputs] = useState<UserInputTypes>(
    local
      ? JSON.parse(local)
      : {
          gender: '_',
          drinks: [0, 0, 0],
          frequency: '-',
          heavyOnceAMonth: '_',
          age: '-',
        }
  )

  const [collectedData, setCollectedData] = useState<DBDataType>()




  const readDataFromDB = async () => {
    console.log('read data')

    const dbRef = ref(getDatabase(app))

    const snap1: DataSnapshot = await new Promise((resolve, reject) => {
      onValue(dbRef, (snap) => resolve(snap), { onlyOnce: true })
    })
    if (snap1.exists()) {
      console.log("READ FROM DB",snap1.val())
      setCollectedData(snap1.val())
    } else {
      console.log('No data in DB')
    }
  }
  const writeUserInputsTODatabase = async (
    perWeek: number,
    gender: string,
    frequency: string,
    heavy: boolean,
    drinks: number[],
    risk: string
  ) => {
    const db = getDatabase();
    
    // Using individual updates instead of a transaction
    try {
      console.log('db updates start');
      
      // Update gender data
      const genderRef = ref(db, `gender/${gender}/${perWeek}`);
      const genderSnapshot = await get(genderRef);
      const genderVal = (genderSnapshot.exists() ? genderSnapshot.val() : 0) + 1;
      await set(genderRef, genderVal);
      
      // Update frequency data
      const frequencyRef = ref(db, `frequency/${gender}/${frequency}`);
      const frequencySnapshot = await get(frequencyRef);
      const frequencyVal = (frequencySnapshot.exists() ? frequencySnapshot.val() : 0) + 1;
      await set(frequencyRef, frequencyVal);
      
      // Update heavy drinking data
      const heavyRef = ref(db, `heavy/${gender}`);
      const heavySnapshot = await get(heavyRef);
      const heavyVal = (heavySnapshot.exists() ? heavySnapshot.val() : 0) + (heavy ? 1 : 0);
      await set(heavyRef, heavyVal);
      
      // Update risk data
      const riskRef = ref(db, `risk/${gender}/${risk}`);
      const riskSnapshot = await get(riskRef);
      const riskVal = (riskSnapshot.exists() ? riskSnapshot.val() : 0) + 1;
      await set(riskRef, riskVal);
      
      // Update drinks data
      const beerRef = ref(db, `drinks/${gender}/beer`);
      const beerSnapshot = await get(beerRef);
      const beerVal = (beerSnapshot.exists() ? beerSnapshot.val() : 0) + drinks[0];
      await set(beerRef, beerVal);
      
      const wineRef = ref(db, `drinks/${gender}/wine`);
      const wineSnapshot = await get(wineRef);
      const wineVal = (wineSnapshot.exists() ? wineSnapshot.val() : 0) + drinks[1];
      await set(wineRef, wineVal);
      
      const snapsRef = ref(db, `drinks/${gender}/snaps`);
      const snapsSnapshot = await get(snapsRef);
      const snapsVal = (snapsSnapshot.exists() ? snapsSnapshot.val() : 0) + drinks[2];
      await set(snapsRef, snapsVal);
      
      console.log('db updates finished');
      readDataFromDB();
    } catch (e) {
      console.error('Database updates failed:', e);
    }
  };
  
  // Don't forget to import these additional Firebase functions at the top of your file:
  // import { getDatabase, ref, set, get } from 'firebase/database';
  
  // Don't forget to import these additional Firebase functions at the top of your file:
  // import { getAuth } from 'firebase/auth';
  // import { getDatabase, ref, set, get } from 'firebase/database';
  useEffect(() => {
    readDataFromDB()
  }, [])

  useEffect(() => {
    if (!collectedData) return
    getDBData(collectedData)
  }, [local, collectedData])

  useEffect(() => {
    // if (!inputs.perweek) {
      inputs.perweek = inputs.drinks.reduce((a, b) => a + b, 0)
    // }
    // if (!inputs.risk) {
      inputs.risk = getRisk(
        inputs.perweek,
        inputs.heavyOnceAMonth === 'y',
        inputs.gender
      )
    // }
    getUserInputs(inputs)
  }, [local, collectedData])

  // change user data
  const genderChange = (value: string | number) => {
    setInputs({ ...inputs, gender: value as string })
  }
  const heavyChange = (value: string | number) => {
    setInputs({ ...inputs, heavyOnceAMonth: value as string })
  }
  const drinksChange = (value: number[]) => {
    console.log("DRINKS CHANGE",value)
    setInputs({ ...inputs, drinks: value })
  }
  const frequencyChange = (value: string) => {
    setInputs({ ...inputs, frequency: value })
  }
  const ageChange = (value: string) => {
    setInputs({ ...inputs, age: value })
  }
  const riskChange = (value: string) => {
    setInputs({ ...inputs, risk: value })
    // getRisk(perWeek, heavyOnceAMonth === 'y', gender)
  }

  const { gender, drinks, frequency, heavyOnceAMonth, age } = inputs
  const questions = TEXT.questions as string[][]
  const frequencyOptions = [
    { label: questions[1][2], id: 'lesthanone' },
    { label: questions[1][3], id: 'onetotwo' },
    { label: questions[1][4], id: 'threetosix' },
    { label: questions[1][5], id: 'daily' },
  ]
  const perWeek = calculateWeeklyGlasses(drinks)

  // "abstinent"-option only valid when no drinks
  if (perWeek === 0)
    frequencyOptions.unshift({ label: questions[1][1], id: 'abstinent' })

  return (
    <StyledCalculator className='Calculator'>
      <TextWidth>
        <h4>{TEXT.title}</h4>
        <div className='info'>
          <p>{TEXT.lead} </p>
        </div>
        <DrinksWrapper className='drinks'>
          <DrinksInput
            current={drinks}
            change={drinksChange}
            disabled={participated}
            labels={TEXT.drinks as string[]}
          />
        </DrinksWrapper>
        <WrapperFull>
          <IconWrapper>
            <InputLabel>{questions[0][0]}</InputLabel>
            <Switch
              current={gender}
              change={genderChange}
              entries={[
                { label: questions[0][1], value: 'f' },
                { label: questions[0][2], value: 'm' },
              ]}
              disabled={participated}
            />{' '}
          </IconWrapper>
        </WrapperFull>
        <WrapperFull>
          <IconWrapper>
            <InputLabel>{questions[3][0]}</InputLabel>
            <Select
              noLabel
              text={TEXT.select}
              current={age}
              disabled={participated}
              entries={[
                { label: questions[3][1], id: 'age_15_24' },
                { label: questions[3][2], id: 'age_25_34' },
                { label: questions[3][3], id: 'age_35_44' },
                { label: questions[3][4], id: 'age_45_54' },
                { label: questions[3][5], id: 'age_55_64' },
                { label: questions[3][6], id: 'age_65_74' },
                { label: questions[3][7], id: 'age_75' },
              ]}
              change={ageChange}
            />
          </IconWrapper>
        </WrapperFull>
        <WrapperFull>
          <IconWrapper>
            <InputLabel>{questions[1][0]}</InputLabel>
            <Select
              text={TEXT.select}
              noLabel
              current={frequency}
              entries={frequencyOptions}
              change={frequencyChange}
              disabled={participated}
            />
          </IconWrapper>
        </WrapperFull>
        <WrapperFull>
          <IconWrapper>
            <InputLabel>{questions[2][0]}</InputLabel>
            <Switch
              current={heavyOnceAMonth}
              change={heavyChange}
              entries={[
                { label: questions[2][1], value: 'y' },
                { label: questions[2][2], value: 'n' },
              ]}
              disabled={participated}
            />
          </IconWrapper>
        </WrapperFull>
        {(gender === '_' ||
          age === '-' ||
          frequency === '-' ||
          heavyOnceAMonth === '_' ||
          (perWeek > 0 && frequency === 'abstinent')) && (
          <IconWrapper className='fullinfo'>{TEXT.fillout}</IconWrapper>
        )}

        <WrapperFull>
          <Button
            type='callToAction'
            disabled={
              participated ||
              gender === '_' ||
              age === '-' ||
              frequency === '-' ||
              heavyOnceAMonth === '_' ||
              (perWeek > 0 && frequency === 'abstinent')
            }
            onClick={() => {
              const perweek = calculateWeeklyGlasses(drinks)

              const risk = getRisk(perweek, heavyOnceAMonth === 'y', gender)
              riskChange(risk)

              // return user inputs to main state
              getUserInputs({ ...inputs, perweek })

              // toggle input elements to not changeable
              setParticipated(true)

              // Write user inputs into local storage
              console.log("WRITE TO LOCAL STORAGE",inputs)
              localStorage.setItem(lSProp, JSON.stringify(inputs))

              // scroll to evaluation after finishing input
              let el = document.getElementById('evaluation')
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }

              // write user inputs to database
              if (collectedData) {
                writeUserInputsTODatabase(
                  perweek,
                  gender,
                  frequency,
                  heavyOnceAMonth === 'y',
                  drinks,
                  risk
                )
              }
            }}
          >
            {!participated
              ? (TEXT.buttons as string[])[0]
              : (TEXT.buttons as string[])[1]}
          </Button>
        </WrapperFull>
        <EarlyFeedback>{TEXT.earlyfeedback}</EarlyFeedback>
        <Disclaimer>{TEXT.disclaimer}</Disclaimer>
      </TextWidth>
    </StyledCalculator>
  )
}

/*
  
  3 Inputs for amount of drinks
  
  */
const StyledDrinksInput = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 5px;
  justify-content: center;
  max-width: 100%;
  .label {
    min-height: 3em;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    flex: 0 0 100%;
  }
`
const DrinkWrapper = styled.div`
  flex: 0 0 calc(33.333%);
  text-align: center;

  img {
    max-width: 200px;
  }
`
const drinkIcons = ['beer.svg', 'wine.svg', 'snaps.svg']
const drinkSubs = ['3dl', '1dl', '3cl']
const DrinksInput = ({
  current,
  change,
  disabled,
  labels,
}: {
  current: number[]
  change: (e: number[]) => void
  disabled: boolean
  labels: string[]
}) => {
  const [drinks, setDrinks] = useState(current)
  const handleChange = (id: number, value: number) => {
    let newDrinks = [...drinks]
    newDrinks[id] = +(value + ''.replace(/^0+/, ''))
    setDrinks(newDrinks)
  }
  useEffect(() => {
    change(drinks)
  }, [drinks])
  return (
    <StyledDrinksInput>
      {drinks.map((m, i) => {
        return (
          <DrinkWrapper key={'drinksinput' + i}>
            <img
              src={require('images/' + drinkIcons[i])}
              style={{ height: '100px' }}
              alt={drinkIcons[i]}
            />
            <InputLabel
              style={{ textAlign: 'center' }}
              className='label drinks'
            >
              {labels[i]}
            </InputLabel>
            <InputSub style={{ textAlign: 'center' }}>{drinkSubs[i]}</InputSub>
            <NumberInput
              current={m}
              change={(val) => handleChange(i, val)}
              id={i}
              disabled={disabled}
            />
          </DrinkWrapper>
        )
      })}
    </StyledDrinksInput>
  )
}

const StyledCalculator = styled.div`
  color: #202346;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  background-color: var(--beige-bright-2);
  background-image: url(${require('../../images/icons__pattern.png')});
  margin-bottom: 60px;
  h4 {
    /* max-width: ${isMobile ? '100%' : '70%'}; */
    margin-left: auto;
    margin-right: auto;
    font-size: 26px;
    line-height: 1.4em;
    /* color: var(--text-color) */
  }
  .info {
    font-family: var(--font-sans-serif);
    font-size: 15px;
    line-height: 1.4em;
    max-width: ${isMobile ? '100%' : '70%'};
    margin-left: auto;
    margin-right: auto;
  }
`
const WrapperFull = styled.div`
  flex: 0 0 100%;
  min-width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  button {
    border-right: 2px solid var(--brandblue-bright-5);
  }
`
const IconWrapper = styled.div`
  flex: ${isMobile ? '0 0 100%' : '0 0 70%'};
  margin-bottom: 40px;
  &.fullinfo {
    font-family: var(--font-sans-serif);
    margin-bottom: 30px;
    line-height: 1.4em;
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    background-color: #d3343f;
    color: var(--site-background);
    padding: 15px 0px;
  }
`
const DrinksWrapper = styled.div`
  min-width: 100%;
  margin-bottom: 40px;
`
const Disclaimer = styled.div`
  font-size: 12px;
  font-family: var(--font-sans-serif);
  line-height: 1.5em;
  max-width: 100%;
  text-align: center;
  margin-bottom: 30px;
`
const EarlyFeedback = styled.div`
  font-size: 15px;
  font-family: var(--font-sans-serif);
  line-height: 1.5em;
  margin-top: 30px;
  margin-bottom: 15px;
  text-align: center;
  a {
    color: var(--brandblue-main) !important;
  }
`
const InputLabel = styled.div`
  font-family: var(--font-sans-serif);
  text-align: left;
  line-height: 1.4em;
  margin-bottom: 15px;
  font-size: 16px;
  flex: 0 0 100%;
  letter-spacing: 0.4px;
  justify-content: center;
  flex: 0 0 100%;
  &.error {
    color: #f00;
  }
  &.drinks {
    margin-bottom: 0;
  }
`
const InputSub = styled.div`
  font-family: var(--font-sans-serif);
  text-align: left;
  font-size: 12px;
  line-height: 1.4em;
  margin-top: -5px;
  margin-bottom: 15px;
`
